import { AXEPTIO_ALL_COOKIES } from '@sortlist-frontend/user-tools';
import { useWindowMessage, WindowMessageParams } from '@sortlist-frontend/utils';
import { getCookie } from 'cookies-next';

import { BriefingTarget, useBriefingUrl } from '_components/Briefing/hooks/useBriefingUrl';
import { SORTLIST_COOKIES } from '_components/Briefing/utils';

type Data = BriefingTarget & { results?: string };

export const OPEN_BRIEFING = 'open-briefing';
export const FINISH_BRIEFING = 'finish-briefing';
export const CLOSE_BRIEFING = 'close-briefing';

type Action = typeof OPEN_BRIEFING | typeof CLOSE_BRIEFING | typeof FINISH_BRIEFING;

export const useBriefingMessage = (params?: WindowMessageParams<Action, Data>) =>
  useWindowMessage<Action, Data>(params);

const encodeSortlistCookies = () => {
  const sortlistCookies = [...SORTLIST_COOKIES, ...AXEPTIO_ALL_COOKIES]
    .map((cookieName) => {
      const cookieValue = getCookie(cookieName);
      if (cookieValue == null) return null;
      return `${cookieName}=${cookieValue}`;
    })
    .filter(Boolean)
    .join('; ');

  return btoa(sortlistCookies);
};

export const useOpenBriefing = () => {
  const getBriefingUrl = useBriefingUrl();

  const openBriefing = (data: Data, options?: { replace?: boolean }) => {
    const redirectUrl = getBriefingUrl(data, {
      search: window.location.search,
      encodedCookies: encodeSortlistCookies(),
    });
    if (options?.replace === true) {
      window.location.replace(redirectUrl);
      return;
    }
    window.open(redirectUrl, '_self');
  };

  return { openBriefing };
};

export const BriefingDialog = () => {
  const { openBriefing } = useOpenBriefing();

  useBriefingMessage({
    onReceiveMessage: async (action, data) => {
      if (action === OPEN_BRIEFING) {
        return openBriefing(data);
      }
    },
    sendToIframeId: 'directory-actions',
  });

  return <div></div>;
};
